import React from "react";
import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SimpleCard } from "../../componentes/Common/SimpleCard";
import { useCasUserContext } from "../../services/casUserContext";
const nameAnalista: string = process.env.REACT_APP_NAME_ANALISTA || '';
const mailAnalista: string = process.env.REACT_APP_MAIL_ANALISTA || '';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useCasUserContext();

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        {user ? (
          <>
            <Typography variant="h4" component="h1">
              No tienes permisos
            </Typography>
            <Typography variant="body1">
              No tienes permisos para acceder a esta sección.
            </Typography>
            <Typography variant="body1">
              Por favor, contacta al analista de investigación para solicitar
              acceso.
            </Typography>
            <SimpleCard
              nombre={nameAnalista}
              cargo="Analista de investigación"
              email={mailAnalista}
            />
          </>
        ) : (
          <>
            <Typography variant="h4" component="h1">
              Usuario no autenticado
            </Typography>
            <Typography variant="body1">
              Debes iniciar sesión para poder acceder al sistema.
            </Typography>
          </>
        )}
        <br />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/inicio")}
        >
          VOLVER
        </Button>
      </div>
    </Container>
  );
};
